<template>
    <span style="color: #2196f3">
      {{ title }}
    </span>
  </template>
  
  <script>
  export default {
    name: "HeadingTitle",
    props: {
      title: {
        type: String,
        default: "title",
        required: true,
      },
    },
  };
  </script>